import Path from "src/constants/path";

/** Paths the native app claims as App/Universal Links; anything else is left to the default routing. */
const IN_APP_PATHS = [
  `/${Path.app}`,
  "/auth/ott-app",
  "/signup/personify-health"
];

export const getAppPathFromUrl = (url: string): string | undefined => {
  const { pathname, search, hash } = new URL(url);
  const isAppPath = IN_APP_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
  return isAppPath ? `${pathname}${search}${hash}` : undefined;
};
